module.exports = __webpack_public_path__ + "static/media/download.e37fc19b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/download.svg
// module id = 594
// module chunks = 46